import React from 'react'
import Classes from '../../Settings.module.css'
import { useDispatch } from 'react-redux';
import { authActions } from '../../../../../../../redux-store';
import { useNavigate } from 'react-router-dom';

export default function Sidebar({ activeTab, setActiveTab }) {

    const navigateTo = useNavigate();

    const dispatch = useDispatch();

    const handleLogout = async () => {
        localStorage.clear();
        sessionStorage.clear();
        await dispatch(authActions.logout());
        navigateTo('/')

    };


    return (
        <ul className={Classes.sidebar} >
            <li className={activeTab === "profile" ? Classes.active : ""}
                onClick={() => setActiveTab("profile")}>
                <h5>Profile</h5>
            </li>

            <li className={activeTab === "preferences" ? Classes.active : ""}
                onClick={() => setActiveTab("preferences")}>
                <h5>Preferences</h5>
            </li>

            <li >
                <a href="https://stripe.com/billing" target='_blank' style={{ color: 'black' }} >
                    <h5>Billing</h5>
                </a>
            </li>

            <li>
                <a onClick={() => handleLogout()}>
                    <h5 className={Classes.colorBlack} >Sign out</h5>
                </a>
            </li>
        </ul>
    )
}
